"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_brand_1 = require("@giphy/js-brand");
const css_1 = require("@emotion/css");
const preact_1 = require("preact");
const fetchError = (0, css_1.css) `
    color: ${js_brand_1.giphyLightGrey};
    display: flex;
    justify-content: center;
    margin: 30px 0;
    font-family: ${js_brand_1.fontFamily.body};
    font-size: 16px;
    font-weight: 600;
    a {
        color: ${js_brand_1.giphyBlue};
        cursor: pointer;
        &:hover {
            color: white;
        }
    }
`;
const FetchError = ({ onClick }) => ((0, preact_1.h)("div", { className: fetchError },
    "Error loading GIFs.\u00A0",
    (0, preact_1.h)("a", { onClick: onClick }, "Try again?")));
exports.default = FetchError;
//# sourceMappingURL=fetch-error.js.map